import ACTIONS from "../../constants/actions";
import _ from 'lodash';

const dataFromLs = localStorage.getItem('favoriteSports');

const initialState = dataFromLs ? JSON.parse(dataFromLs) : [];

export default function favoriteSports(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.FAVORITE_SPORTS.TOGGLE:
			const intersect = _.intersection(state, [action.data]);
			const data = _.pullAll([...state, action.data], intersect);
			localStorage.setItem('favoriteSports', JSON.stringify(data));
			return data;

		default:
			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/favorite-sports.js